<template>
  <div class="3c">
    <h3 class="uk-margin-medium-top">3C ANÁLISIS DE LA FUENTE DE PAGO</h3>
    <p>Contesta las siguientes preguntas:</p>
    <form id="form" class="uk-text-left">

      
      <div class="uk-margin">
        <label >a) Actividad económica del cliente</label>
        <select class="uk-select" v-model="data['a - Actividad económica del cliente']" required>
          <option value="7" id="Asaliariado empresa privado" >Asaliariado empresa privado</option>
          <option value="6" id="Asaliariado empresa pública" >Asaliariado empresa pública</option>
          <option value="5" id="Jubilado (recibe jubilación)">Jubilado (recibe jubilación)</option>
          <option value="2" id="Ama de casa">Ama de casa</option>
          <option value="7" id="Comerciante (compra y vende)">Comerciante (compra y vende)</option>
          <option value="7" id="Microempresario artesano (artesanías)">Microempresario artesano (artesanías)</option>
          <option value="5" id="Independiente (profesional)">Independiente (profesional)</option>
          <option value="3" id="Oficios independientes (ej. albañil)">Oficios independientes (ej. albañil)</option>
          <option value="4" id="Agricultor / Ganadero">Agricultor / Ganadero</option>
        </select>      
      </div>

      <div class="uk-margin">
        <label >b) Destino del Crédito</label>
        <select class="uk-select" required v-model="data['b - Destino del Crédito']" >
          <option value="7">Inversión para el agro/ganadería</option>
          <option value="7">Inversión en la empresa o negocio (equipos, maquinaria)</option>
          <option value="7">Inversión en la compra de mercadería para ventas</option>
          <option value="6">Arreglo, mejoras de vivienda propia</option>
          <option value="5">Compra de vehículos (incluye motos)</option>
          <option value="3">Compra de bienes no duraderos: mueblres, electrónica, salud otros (consumo)</option>
          <option value="2">Pago de obligaciones o deudas con terceros</option>
        </select>
      </div>


      <div class="uk-margin">
        <label >c) Años de experiencia en la actividad económica o trabajando en la empresa</label>
        <select class="uk-select" required v-model="data['c - Años de experiencia en la actividad económica']" >
          <option value="7">1       Más de 15 años</option>
          <option value="6">2      Entre 12 y 15 años</option>
          <option value="5">3      Entre 10 y 12 años</option>
          <option value="4">4      Entre 8 y 10 años</option>
          <option value="3">5      Entre 5 y 8 años</option>
          <option value="2">6      Entre 2 y 5 años</option>
          <option value="1">7      Entre 1 y 2 años</option>
        </select>
      </div>


      <div class="uk-margin">
        <label >d) Estado civil de socio</label>
        <select class="uk-select" required v-model="data['d - Estado civil de socio']" >
          <option value="7">Casado</option>
          <option value="6">Unión Libre</option>
          <option value='5'>Viudo</option>
          <option value="3">Soltero</option>
          <option value="2">Divorciado</option>
        </select>
      </div>



      <div class="uk-margin">
        <label >e) Edad del Socio</label>
        <select class="uk-select" required v-model="data['e - Edad del Socio']" >
          <option value="7">De 18 a 25 años</option>
          <option value="5">De 25 a 30 años</option>
          <option value="3">de 30 a 40 años</option>
          <option value="1">De 40 a 50</option>
          <option value="1">De 50 a 65 años</option>
          <option value="1">Mas de 65</option>
        </select>
      </div>


      <div class="uk-margin">
        <label >g)  Nivel de Educación</label>
        <select class="uk-select" required v-model="data['f -  Nivel de Educación']" >
          <option value="7">Profesionista</option>
          <option value="6">Universidad trunca</option>
          <option value="5">Preparatoria o bachillerato</option>
          <option value="4">Secundaria</option>
          <option value="3">Primaria</option>
          <option value="1">Sin estudios</option>
        </select>
      </div>



      <div class="uk-margin uk-text-center">
        <button class="uk-button uk-button-primary">siguiente</button>
      </div>


    </form>
  </div>
</template>

<script>
export default {
  data: function(){
    return {
      data : this.$score['3C CAPACIDAD DE PAGO POR DATOS ACTIVIDAD ECONÓMICA'] ? this.$score['3C CAPACIDAD DE PAGO POR DATOS ACTIVIDAD ECONÓMICA'] : {},
      act:'',
    }
  },
  computed:{
    calif : function(){
      var value = 0.0
      for (var i in this.data){
        if(i == 'PUNTAJE TOTAL'){
          continue
        }
        if(!isNaN(parseFloat(this.data[i]))){
          value += parseFloat(this.data[i])
        }
      }
      value = value * 70.0 / 56.0
      value = value.toFixed(1)
      this.data['PUNTAJE TOTAL'] = value
      // this.data['a - Actividad económica del cliente'] = document.getElementById(this.$score.act).value
      return value
    }
  },
  mounted: function(){
    document.getElementById('form').addEventListener('submit',function(e){
      e.preventDefault()
      var cal = this.calif + 1
      this.$score['3C CAPACIDAD DE PAGO POR DATOS ACTIVIDAD ECONÓMICA'] = this.data
      sessionStorage.setItem('score',JSON.stringify(this.$score))
      this.$router.push('4c')
    }.bind(this))
    window.scroll(0,0)
    this.$score = JSON.parse(sessionStorage.getItem('score'))
    if(this.$score['3C CAPACIDAD DE PAGO POR DATOS ACTIVIDAD ECONÓMICA']) this.data = this.$score['3C CAPACIDAD DE PAGO POR DATOS ACTIVIDAD ECONÓMICA']
    this.act = this.$score.act
    document.getElementById(this.act).selected = true
    this.data['a - Actividad económica del cliente'] = document.getElementById(this.act).value


  }
    
}
</script>
